<template>
  <div ref="root">
    <transition name="fade">
      <div class="overlay" v-if="!done">
        <div v-if="animating" class="container" ref="container">
          <div v-for="i in 10" :key="i"
               ref="petals">
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import Color from 'color'

  export default {
    name: 'LoadingSpinner',
    methods: {
      getListenPetal() {
        return this.$refs.petals[5]
      },
      setListener(listener) {
        const p = this.getListenPetal()
        if (this.oldListener) {
          p.removeEventListener('animationend', this.oldListener)
          p.removeEventListener('webkitAnimationEnd', this.oldListener)
        }
        p.addEventListener('animationend', listener)
        p.addEventListener('webkitAnimationEnd', listener)
        this.oldListener = listener
      },
      requestStop() {
        if (localStorage.spinnerSeen) {
          this.finalEnd()
        } else {
          this.setListener(this.finalEnd)
        }
      },
      async restartAnimation() {
        this.animating = false
        await this.$nextTick()
        this.animating = true
        await this.$nextTick()
        this.setListener(this.animationEnd)
      },
      async animationEnd() {
        await this.restartAnimation()

        const c = this.$refs.container
        const white = Color('white')

        c.style.setProperty('--even-background', white.darken(Math.random()))
        c.style.setProperty('--odd-background', white.darken(Math.random()))
      },
      finalEnd() {
        this.done = true
        localStorage.spinnerSeen = true
      },
    },
    data() {
      return {
        animating: true,
        done: false,
      }
    },
    mounted() {
      this.setListener(this.animationEnd)
    },
  }
</script>

<style lang="scss" scoped>
  .fade-enter {
    opacity: 0;
  }

  .fade-enter-to {
    opacity: 1;
  }

  .fade-leave {
    opacity: 1;
  }

  .fade-leave-to {
    opacity: 0;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }

  .overlay {
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: hsla(0, 0, 100, 1);
  }

  .container {
    width: 0;
    height: 0;
    --loading-dimension: 2em;
    --even-background: #{darken(white, 5)};
    --odd-background: #{darken(white, 10)};
  }

  .container div {

    border-radius: 5px 90%;
    border-style: solid;
    border-width: 3px;
    border-color: white;
    height: var(--loading-dimension);
    margin: auto;
    width: var(--loading-dimension);
    position: absolute;
    /*
        top: 50px;
        left: 50px;
    */
    transform-origin: left top;
    opacity: 0;

    &:nth-of-type(odd) {
      background: var(--odd-background);
    }

    &:nth-of-type(even) {
      background: var(--even-background);
    }

    $i: 1;
    $petals: 10;
    @for $i from 1 to ($petals + 1) {
      &:nth-of-type(#{$i}) {
        animation-timing-function: ease-out;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;
        animation-delay: ($i - 1) * .05s;
        animation-duration: 3s;
        animation-name: spin#{$i};
        @keyframes spin#{$i} {
          0% {
            opacity: 0;
            transform: rotate(0deg) scale(0.01);
          }
          33% {
            opacity: 1;
            transform: rotate(($petals - $i) * (360deg / $petals)) scale(1);
          }
          66% {
            opacity: 1;
            transform: rotate(($petals - $i) * (360deg / $petals)) scale(1);
          }
          100% {
            transform: rotate(720deg) scale(0.01);
          }
        }
      }
    }
  }
</style>
